import { ProfilePicture } from '@/components/Atoms/ProfilePicture/ProfilePicture';
import type { IPerson } from '@/interfaces';
import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './PersonCard.module.css';

interface IPersonCardProps {
    boxed?: boolean;
    person: IPerson;
    subTitle?: string;
    withImage?: boolean;
}

/**
 * A component to display a person's picture and details.
 */
export const PersonCard: FCl<IPersonCardProps> = ({ className, boxed = false, person, subTitle, withImage = true }) => {
    if (!person) {
        return null;
    }
    const image = withImage && <ProfilePicture alt={person.name} src={person.imageUrl} className={styles.image} />;

    subTitle ??= person.position;
    const cardContent = (
        <>
            {image}
            <div className={styles.detail}>
                <strong>{person.displayName}</strong>
                {subTitle && <em>{subTitle}</em>}
            </div>
        </>
    );

    if (person.url && person.url.length > 0) {
        return (
            <a
                href={person.url}
                className={classNames(styles.card, 'cds-t-body', className, { [styles.boxed]: boxed })}
            >
                {cardContent}
            </a>
        );
    }

    return <div className={classNames(styles.card, className, { [styles.boxed]: boxed })}>{cardContent}</div>;
};
